import leafio from '@montugroup/themes/brands/leafio';
import { BrandThemeProvider } from '@montugroup/themes/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import type { FC, PropsWithChildren } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ApiProvider } from './ApiProvider';
import { AuthProvider } from './AuthProvider';
import { LaunchDarklyProviderWrapper } from './LaunchDarklyProvider';
import { ReactQueryProvider } from './ReactQueryProvider';
import { SnowplowProvider } from './SnowplowProvider';

export const Providers: FC<PropsWithChildren> = ({ children }) => (
  <HelmetProvider>
    <LaunchDarklyProviderWrapper>
      <ReactQueryProvider>
        <AuthProvider>
          <ApiProvider>
            <LocalizationProvider dateAdapter={AdapterLuxon}>
              <SnowplowProvider>
                <BrandThemeProvider theme={leafio}>{children}</BrandThemeProvider>
              </SnowplowProvider>
            </LocalizationProvider>
          </ApiProvider>
        </AuthProvider>
      </ReactQueryProvider>
    </LaunchDarklyProviderWrapper>
  </HelmetProvider>
);
